import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export default function GroupDetailProfile({ group }) {
  return (
    <Box>
      <Typography
        sx={{
          color: "#061522",
          fontFamily: "Inter",
          fontSize: 18,
          fontWeight: 500,
          lineHeight: "34px",
        }}
      >
        {group.name}
      </Typography>
    </Box>
  );
}
